<template>
    <div id="Recycle-pop" class="My_popup">
        <div class="My_popup_wrap">
            <span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer;">닫기</span>
            <div class="My-popup-title">은평구 광역자원 순환센터</div>
            <div class="My-popup-content green-line">
                <div class="recycle-detail01">
                    <div class="pop_title">추진 경과 및 일정</div>
                    <div class="re_box">
                        <ul class="re_timeline">
                            <li><p class="re_time">2000.08</p>
                                <p class="re_txt">도시계획시설(폐기물 처리시설) 결정,고시</p></li>
                            <li><p class="re_time">2008. 12</p>
                                <p class="re_txt">
                                    음식물처리시설 건립계획 수립(민간투자사업)<br>
                                    (음식물처리시설 100톤, 압축적환 180톤, 재활용 30톤)
                                </p></li>
                            <li><p class="re_time">2012. 05</p>
                                <p class="re_txt">민간투자사업(음식물처리시설) 취소</p></li>
                            <li><p class="re_time">2013. 10</p>
                                <p class="re_txt">광역 재활용처리시설로 부지활용 계획 수립</p></li>
                            <li><p class="re_time">2014. 02</p>
                                <p class="re_txt">서대문‧마포구에서 광역시설 사업참여 동의서 제출</p></li>
                            <li><p class="re_time">2014. 02 ~ 2015. 02</p>
                                <p class="re_txt">
                                    도시계획 용도지역 변경 추진완료<br>
                                    [변경사항] 자연녹지지역(건폐율 20%) → 제2종일반주거지역(건폐율 60%)
                                </p></li>
                            <li><p class="re_time">2015. 05 ~ 12</p>
                                <p class="re_txt">재활용처리시설 구성사항 검토</p></li>

                            <li>
                                <p class="re_time">2017. 11</p>
                                <p class="re_txt">은평광역자원순환센터 건립 기본계획 수립(부분지하)</p>
                            </li>
                            <li>
                                <p class="re_time">2018. 08</p>
                                <p class="re_txt">은평광역자원순환센터 건립추진 변경계획 수립(완전지하)</p>
                            </li>
                            <li>
                                <p class="re_time">2019. 03</p>
                                <p class="re_txt">완전지하화 계획변경에 대한 참여구 협약체결</p>
                            </li>
                            <li>
                                <p class="re_time">2019. 11</p>
                                <p class="re_txt">한국지방행정연구원 타당성조사 완료</p>
                            </li>
                            <li>
                                <p class="re_time">2019. 12</p>
                                <p class="re_txt">중앙 투자심사 통과</p>
                            </li>
                            <li>
                                <p class="re_time">2020. 03</p>
                                <p class="re_txt">기본 및 실시설계용역 착수</p>
                            </li>
                            <li>
                                <p class="re_time">2021. 04</p>
                                <p class="re_txt">토목(흙막이) 공사 착공</p>
                            </li>
                            <li>
                                <p class="re_time">2022. 07</p>
                                <p class="re_txt">건축 및 설비공사 착공</p>
                            </li>
                            <li>
                                <p class="re_time">2022. 07 ~ 2024. 12</p>
                                <p class="re_txt">건축 및 설비공사 시행</p>
                            </li>
                            <li>
                                <p class="re_time">2025. 01 ~ 2025. 04</p>
                                <p class="re_txt">시운전 및 준공</p>
                            </li>
                        </ul>
                    </div>

                    <div class="pop_title">오해와 진실</div>
                    <div class="re_box">
                        <ul class="re_news">
                            <li><p class="tit">은평 광역자원순환센터는 거대한 쓰레기장이다?!</p>
                                <p class="txt">
                                    은평 광역자원순환센터는 소각시설이 아니며 음식물처리시설도 아닙니다.<br>
                                    재활용을 병류, 캔류, 종이류 등으로 분류하는 재활용품선별시설과 효율적인<br>
                                    처리를 위해 골목길에서 수거한 일반(대형) 폐기물을 큰 차량으로 옮겨싣는 적환시설입니다. </p>
                            </li>
                            <li><p class="tit">은평구·서대문구·마포구의 쓰레기가 은평구로 온다?!</p>
                                <p class="txt">
                                    은평구, 서대문구, 마포구의 재활용품만 반입됩니다. 생활폐기물, 음식물폐기물은 반입되지 않습니다. 그리고, 은평구의 생활폐기물은
                                    ‘마포자원회수시설(소각장)’로 음식물폐기물은 ‘서대문구 난지음식물류폐기물 자원화시설’로 반입됩니다.
                                </p></li>
                            <li><p class="tit">시설 건립후에는 종로구, 용산구 쓰레기가 와도 막을수 없다?!</p>
                                <p class="txt">
                                    은평·서대문·마포 3개구의 재활용품 발생량을 기준으로 시설용량을 산정하였습니다. 물리적으로 시설용량(150톤/일)이상의 초과 반입이 불가합니다.
                                </p></li>
                            <li><p class="tit">침출수가 발생하여 창릉천이 오염된다.?!</p>
                                <p class="txt">
                                    폐기물압축, 실내청소, 세차 등으로 시설내에서 발생되는 침출수는 폐수처리시설을 거쳐 법적허용기준에 맞추어 정화처리되어 공공하수관으로 방류되며 창릉천으로
                                    방류하지 않습니다.
                                </p></li>
                            <li><p class="tit">국립공원으로 지정된 북한산 인근에는 시설건립이 불가하다?!</p>
                                <p class="txt">
                                    유사한 중구자원재활용처리장은 도심 한가운데인 서소문공원 지하에 위치하고 있으며, 덕수궁과 600m, 숭례문과 460m, 프랑스대사관과 307m 떨어져
                                    있으나, 악취 등 주민불편 민원이 없습니다.
                                </p></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecycleInfoWin',
    methods: {
        closeClickHandler () {
            this.$emit('close-info-win')
        }
    }
}
</script>

<style scoped>

</style>
